import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { providerMeta } from '../../services/ai/aiSettings';
import './aiApiboo.css';

/**
 * The strip above the composer whenever the next turn goes through the
 * Apiboo assistant (22.08.2026) - one line, never a modal wall: the "where is
 * this going" line with the one-click route to bringing a key.
 *
 * The dismissible FIRST-USE variant that used to precede it was removed on the
 * owner's instruction (16.09.2026). The disclosure it carried is not lost: this
 * standing line says the Apiboo assistant is in use and never goes away, the
 * "what's sent" hint under the composer spells out what is transmitted on every
 * turn, Settings -> AI Chat carries the full text, and FirstRunConsent links the
 * privacy policy. Do not reintroduce a one-time notice in its place - a notice
 * that disappears after the first message is the weaker disclosure of the two.
 */
function AiFallbackNotice({ fallbackFrom, selectedProvider, onOpenSettings }) {
  const { t } = useTranslation();

  const fellBack = Boolean(fallbackFrom) && selectedProvider && !providerMeta(selectedProvider).keyless;
  const text = fellBack
    ? t('aiChat.fallbackNotice', { provider: providerMeta(selectedProvider).label })
    : t('aiChat.apibooNotice');
  return (
    <div className="ai-fallback-notice" data-testid="ai-fallback-notice" role="status">
      <Sparkles size={12} className="ai-fallback-notice__icon" />
      <span className="ai-fallback-notice__text">{text}</span>
      {onOpenSettings && (
        <button type="button" className="ai-fallback-notice__btn" onClick={onOpenSettings}>
          {t('aiChat.openSettings')}
        </button>
      )}
    </div>
  );
}

export default AiFallbackNotice;
